import { render, staticRenderFns } from "./Zelle.vue?vue&type=template&id=2c85645e&lang=pug"
import script from "./Zelle.vue?vue&type=script&lang=js"
export * from "./Zelle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports